export default {
  deleteEmailTemplateModal: {
    title: 'Delete template {{ templateName }}',
    confirmCheckbox: {
      label: 'Yes I confirm I would like to delete this template',
    },
    alert: {
      body: 'WARNING: By deleting this email template, any automations that are currently setup to use it will no longer be sent. Are you sure you would like to continue?',
    },
  },
  duplicateEmailTemplateModal: {
    title: 'Duplicate template {{ templateName }}',
    templateInput: {
      label: 'New template name',
    },
  },
  emailTemplateEditor: {
    unlayerEmailEditor: {
      title: 'Unlayer Email Editor',
    },
    beeEmailEditor: {
      title: 'Bee Email Editor',
    },
  },
  emailTemplates: {
    headerBar: {
      breadcrumb: 'Settings /',
      title: 'Email templates',
      searchInput: {
        placeholder: 'Search for email template',
      },
    },
    emailTemplatesTable: {
      table: {
        headers: {
          emailTemplateName: 'Email template name',
          subjectName: 'Subject name',
          lastUpdated: 'Last updated',
        },
      },
    },
    emailTemplatesTile: {
      image: {
        alt: '{{ title }} email template preview',
      },
    },
  },
  importEmailTemplateModal: {
    title: 'Import an email template',
  },
};
